export class VerticalMenuItem {
  label: string;
  icon?: string;
  routerLink?: string;
  state?: string;
  active?: boolean;
  expanded?: boolean;
  disabled?: boolean;
  command?: Function;
  items?: VerticalMenuItem[];
  parent?: VerticalMenuItem;
  hide?: boolean;
  anchorId?: string;
}
